import createReducer from "../../createReducer";
import { googleSheetsAuthHandlers } from "../handlers";
import { IGoogleSheetsState } from "../types";

export const googleSheetsAuth: IGoogleSheetsState = {
    isLoading: false,
    error: null,
    authUrl: null,
};

export default createReducer(googleSheetsAuth, googleSheetsAuthHandlers);
